import React, { useState } from 'react';
import { Button } from 'antd';
import { EyeOutlined, PaperClipOutlined } from '@ant-design/icons';
import AttachmentPreviewModal from '../AttachmentPreviewModal';

function normalizeAttachmentItem(item) {
  if (!item) return null;
  if (typeof item === 'string') {
    let path = item.trim();
    if (!path.startsWith('/uploads/')) {
      if (path.startsWith('/admin/contract-approval-files/')) path = `/uploads${path}`;
      else if (path.startsWith('admin/contract-approval-files/')) path = `/uploads/${path}`;
      else if (path.startsWith('expense/')) path = `/uploads/${path}`;
    }
    const name = path.split('/').pop() || '附件';
    return { path, name: decodeURIComponent(name) };
  }
  const path = item.path || item.file_path;
  if (path) {
    const name = item.name || item.file_name || path.split('/').pop() || '附件';
    return { path, name };
  }
  return null;
}

export default function SealApprovalAttachmentsView({ attachments = [], title = '文件' }) {
  const [previewItem, setPreviewItem] = useState(null);
  const items = (attachments || []).map(normalizeAttachmentItem).filter(Boolean);
  if (!items.length) return null;

  return (
    <>
      <div className="seal-approval-attachments">
        {title ? <div className="seal-approval-attachments-title">{title}</div> : null}
        <ul className="seal-approval-attachments-list">
          {items.map((item) => (
            <li key={item.path}>
              <PaperClipOutlined style={{ marginRight: 6 }} />
              <Button
                type="link"
                size="small"
                className="seal-approval-attachments-link"
                icon={<EyeOutlined />}
                onClick={() => setPreviewItem(item)}
              >
                {item.name}
              </Button>
            </li>
          ))}
        </ul>
      </div>
      <AttachmentPreviewModal
        item={previewItem}
        open={Boolean(previewItem)}
        onClose={() => setPreviewItem(null)}
      />
    </>
  );
}
